export default __webpack_public_path__ + "static/media/it.3ec34f01.jpg";